module.exports = __webpack_public_path__ + "static/media/product-1.046c7d08.png";